import { FC } from 'react';
import { Grid, OnDesktop, OnMobile, SimpleLabel } from '@hopskipdrive/react-components';

interface CancellationReasonProps {
  canceledAt: string;
  reason: string;
}

export const CancellationReason: FC<CancellationReasonProps> = ({ canceledAt, reason }) => (
  <Grid container justifyContent="center">
    <OnDesktop>
      <SimpleLabel
        mt={4}
        textColor="text"
        style={{ padding: '4px 16px' }}
        data-testid="ride-status"
        bgColor="light-orange"
        label={`Canceled on ${canceledAt} with reason "${reason}"`}
      />
    </OnDesktop>
    <OnMobile>
      <SimpleLabel
        mt={4}
        textColor="text"
        style={{ padding: '4px 16px' }}
        data-testid="ride-status"
        bgColor="light-orange"
        label={`Canceled on ${canceledAt} with reason "${reason}"`}
        size="medium"
        sx={{
          height: 'auto',
          '& .MuiChip-label': {
            display: 'block',
            whiteSpace: 'normal',
          },
        }}
      />
    </OnMobile>
  </Grid>
);
